<template>
<td colspan="1">

<button style="margin-right:0.3rem" v-if="element.status.id!=0" :class="barva(element.status)" v-for="element in list" :title="title(element)">
    {{element.naziv}}</button>

</td>
</template>
<script>
export default {
  props: {
   list:Array,
   displayname:String,
   dataitemname:String,
   hover:String,
   sifrant:Array,
   sifrantid:String,
    dataItem: Object,
  },
  created(){
    console.log(this.list);
 
  },
  methods :{
    title(element){

        let date=element.izbrandatumdolocitvestatusa?' dne: '+ new Date(element.izbrandatumdolocitvestatusa).toLocaleDateString('SL-si'):'';

      return element.status.naziv + date;

    },
    barva: function(status){
          


          return {
            'k-button':true,
            'k-primary':status.naziv=='aktiven',
            'k-error':status.naziv=='odstop',
            'k-warning':status.naziv=='mirovanje',

          }

      }
  },
  
  
};
</script>